import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { ADMISION } from './Styles/StylesAdmision';
import logo from "../../assets/img/logo-TAD-d.png";
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";


class ReciboDePago extends Component {
    state = {  }

    ajustar = (tam, num) => {
        if (num.toString().length <= tam) return this.ajustar(tam, "0" + num)
        return num;
    }

    contenido = (tipo) => {
        const styles = StyleSheet.create(ADMISION[0]);
        let { datos, qrCode } = this.props;

        let items = (dato) => (
            dato.map(option => (
                <View key={option[0]} style={[styles.row]}>
                    <Text style={[styles.colTablaRec1, styles.font8, styles.bordeCol11, styles.center]}>{option.id}</Text>
                    <Text style={[styles.colTablaRec2, styles.font8, styles.bordeCol9, styles.center]}>{option.fecha}</Text>
                    <Text style={[styles.colTablaRec3, styles.font8, styles.bordeCol9]}>{option.banco} - {option.item}</Text>
                    <View key={option[0]} style={[styles.colTablaRec4, styles.bordeCol9, styles.center]}>
                        <Text style={[ styles.font8]}>{formatNumber(option.haber)} Bs.</Text>
                        {/* <Text style={[ styles.font8, {color:"#c60000"}]}>{formatReconver(option.haber)} Bs.</Text> */}
                    </View>
                </View>
            ))
        )
        

        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>TEACHER AT DOOR</Text>
                        <Text style={[styles.textPeq]}>Clases de Inglés personalizadas</Text>
                    </View>
                    <Text style={[styles.token]}>N° - {this.ajustar(9, datos.id)}</Text>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    RECIBO DE PAGO
                </Text>

                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DEL ESTUDIANTE</Text>
                    <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.col2, styles.font9]}>Cédula de Identidad: {datos.ci}</Text>
                            <Text style={[styles.col4, styles.font9, {textAlign: "right"}]}>Nombres y Apellidos: {datos.estudiante}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4, marginTop: 5}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. DETALLES DE LA TRANSACCIÓN</Text>

                    <View style={[styles.row, {marginTop: 5}]}>
                        <Text style={[styles.colTablaRec1, styles.font9, styles.bordeCol11, styles.borderTop,  styles.center, {backgroundColor: "#888", color:"#FFF"}]}>Num.</Text>
                        <Text style={[styles.colTablaRec2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#888", color:"#FFF"}]}>Fecha</Text>
                        <Text style={[styles.colTablaRec3, styles.font9, styles.bordeCol9, styles.borderTop, {backgroundColor: "#888", color:"#FFF"}]}>Descripción</Text>
                        <Text style={[styles.colTablaRec4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#888", color:"#FFF"}]}>Monto</Text>
                    </View>
                    {items(datos.transacciones)}
                    <View style={[styles.row]}>
                        <Text style={[styles.colTablaRec5, styles.font9, {paddingTop: 4, paddingRight: 5, paddingLeft: 5, borderBottom: 0.5, borderLeft: 0.5}]}>MÉTODO DE PAGO: <Text style={{color:"#c60000"}}>{datos.metodo}</Text></Text>
                        <Text style={[styles.colTablaRec6, styles.font9, {color:"#c60000", textAlign: "right", paddingTop: 4, paddingRight: 5, borderBottom: 0.5}]}>TOTAL PAGADO</Text>

                        <View style={[styles.colTablaRec4, styles.bordeCol9, styles.center]}>
                            <Text style={[ styles.font10]}>{formatNumber(datos.total)} Bs.</Text>
                            {/* <Text style={[ styles.font10, {color:"#c60000"}]}>{formatReconver(datos.total)} Bs.</Text> */}
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <Text style={[styles.tipo, {textAlign: "right", marginTop: 10}]}>{tipo}</Text>
                </View>

                <View style={[styles.footer3, {marginTop: 10}]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col9]}>
                            <Text style={[styles.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar este recibo vaya al enlace: https://iudlm.com/recibo?code={(datos.token).substring(0,10)}. También puedes escanear el código qr de la derecha.
                            </Text>
                            <Text style={[styles.linea2]}></Text>
                            <Text style={[styles.encabezado]}>
                                Sede Chacao | Academia de inglés Venezuela | Multicentro Empresarial del Este, Núcleo A, torre Libertador, piso 17, oficina A-171 Edo Miranda Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado, {marginTop: -5}]}>
                                Teléfono: +58 (414) 0862068 | Email: administration@tadenglishclass.com
                            </Text>
                        </View>
                        <View style={[styles.col10]}>
                            <Image
                                style={[styles.logoQr, {left:20}]}
                                src={qrCode}
                            />
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }
    render() {
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Recibo de Pago">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido("ORIGINAL - INSTITUTO")}
                        </View>
                        <View style={[styles.font9, {paddingTop: 20, paddingBottom: 20}]}>
                            <Text>{'-'.repeat(192)}</Text>
                        </View>
                        <View>
                            {this.contenido("COPIA - ESTUDIANTE")}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default ReciboDePago;


// WEBPACK FOOTER //
// ./src/components/Reportes/ReciboDePago.jsx